import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useState, useEffect } from 'preact/hooks';
import { useLocation } from 'preact-iso';
import { SettingsNavigation } from './SettingsNavigation';
import { TopNavigation } from '../TopNavigation';
import { SettingsProfile } from './SettingsProfile';
import { SettingsCompany } from './SettingsCompany';
import { SettingsUsers } from './SettingsUsers';
import { SettingsCustomers } from '@/components/settings/customers/SettingsCustomers';
import { useAuth } from '../../auth/useAuth';
import { SettingsAuthentication } from './SettingsAuthentication';
import { SettingsErrorQueue } from './SettingsErrorQueue';
import { SettingsIntegrations } from './SettingsIntegrations';
export function Settings({ activeSection: initialSection, clientCompanyId, onBackToApp }) {
    const [activeSection, setActiveSection] = useState(initialSection || 'settings/profile');
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const auth = useAuth();
    const location = useLocation();
    // Update activeSection when route changes
    useEffect(() => {
        if (initialSection) {
            setActiveSection(initialSection);
        }
    }, [initialSection]);
    // Workspace selection is managed by Home/bootstrap; settings URLs are company-level
    const getNavigationUrl = (section) => {
        const effectiveClientCompanyId = clientCompanyId || '';
        if (effectiveClientCompanyId) {
            return `/company/${effectiveClientCompanyId}/${section}`;
        }
        // If we don't have the required data, we can't navigate - this shouldn't happen in normal flow
        console.error('Missing clientCompanyId for navigation');
        return `/company/${effectiveClientCompanyId}/${section}`;
    };
    const handleSectionChange = (section) => {
        setActiveSection(section);
        const url = getNavigationUrl(section);
        location.route(url);
    };
    const handleBackToApp = () => {
        if (onBackToApp) {
            onBackToApp();
            return;
        }
        const effectiveClientCompanyId = clientCompanyId || '';
        if (!effectiveClientCompanyId) {
            location.route('/');
            return;
        }
        // Let the company bootstrap route handle workspace selection
        location.route(`/company/${effectiveClientCompanyId}`);
    };
    const handleMobileMenuToggle = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };
    const renderMainContent = () => {
        switch (activeSection) {
            case 'settings/profile':
                return _jsx(SettingsProfile, {});
            case 'settings/company':
                return (_jsx(SettingsCompany, { onNavigateHome: onBackToApp, companyId: clientCompanyId ?? auth.userProfile?.ClientCompanyId }));
            case 'settings/customers':
                return _jsx(SettingsCustomers, { clientCompanyId: clientCompanyId });
            case 'settings/authentication':
                return _jsx(SettingsAuthentication, { clientCompanyId: clientCompanyId });
            case 'settings/users':
                return _jsx(SettingsUsers, { clientCompanyId: clientCompanyId });
            case 'settings/integrations':
                return _jsx(SettingsIntegrations, {});
            case 'settings/error-queue':
                return _jsx(SettingsErrorQueue, {});
            default:
                return _jsx(SettingsProfile, {});
        }
    };
    return (_jsxs("div", { className: "min-h-screen bg-slate-50 dark:bg-slate-900 flex", children: [_jsx(SettingsNavigation, { activeSection: activeSection, onSectionChange: handleSectionChange, onBackToApp: handleBackToApp, isOpen: isMobileMenuOpen, onToggle: handleMobileMenuToggle }), _jsxs("div", { className: "flex-1 lg:ml-64 flex flex-col", children: [_jsx(TopNavigation, { onMenuToggle: handleMobileMenuToggle, hideCompanyWorkspaceSelector: true }), _jsx("main", { className: "flex-1 overflow-auto bg-slate-50 dark:bg-slate-800", children: _jsx("div", { children: renderMainContent() }) })] })] }));
}
